module.exports = __webpack_public_path__ + "34bc775d/img/saly-icon.39e12342.jpg";